export type AutoValidationLevels = "error" | "warning";
export const AutoValidationMessage = "Значение не равно вычисленному по формуле";
